import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseRestService} from '../common/BaseRestService';
import {UpcomingEvents} from '../../types/organization/upcoming-events';

@Injectable()
export class OrganizationUpcomingEventsRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('resources/scoutsorg/events');
  }

  getAllUpcomingEvents(id: number, endDate: number): Observable<UpcomingEvents[]> {
    const params = {
      params: new HttpParams()
        .set('endDate', String(endDate))
        .set('scoutOrgId', String(id))
    };
    return this.http.get<UpcomingEvents[]>(this.getEndpoint(), params);
  }

}
